import {FC, useEffect} from "react";
import {Box, CircularProgress, styled, Typography} from "@mui/material";
import NProgress from "nprogress";

const Progress = styled(CircularProgress) (
    `
        color: #1F57B5;
    `
)

interface LoadingOverlayProps {
    active: boolean;
    text?: string;
}

const LoadingOverlay:FC<LoadingOverlayProps> = ({active, text = ""}) => {

    useEffect(() => {
        NProgress.start();

        return () => {
            NProgress.done();
        };
    }, []);

    return (
        <>
            <Box zIndex={100000} height={"100%"} width={"100%"} position={"fixed"} top={0} left={0} display={"flex"} flexDirection={"column"} gap={"24px"} justifyContent={"center"} alignItems={"center"} sx={{background: "rgba(255, 255, 255, 0.93)",
                transition: "opacity 0.25s",
                opacity: `${active ? '1' : '0'}`,
                pointerEvents: (active ? "all" : "none")}}>
                {active && (
                    <>
                        <Progress size={48} disableShrink thickness={3} />
                        {text && (
                            <Typography px={"16px"} textAlign={"center"} variant={"body1"} color={"#1F57B5"} fontSize={"16px"} lineHeight={"24px"} fontWeight={500}>
                                {text}
                            </Typography>
                        )}
                    </>
                )}
            </Box>
        </>
    )
}

export default LoadingOverlay;
